var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "vs-table",
    {
      staticClass: "table",
      attrs: {
        multiple: _vm.multiple,
        "no-data-text": "No tienes documentos",
        data: _vm.documents
      },
      scopedSlots: _vm._u([
        {
          key: "default",
          fn: function(ref) {
            var data = ref.data
            return _vm._l(data, function(tr, indextr) {
              return _c(
                "vs-tr",
                { key: indextr, attrs: { data: tr } },
                [
                  _c("vs-td", { attrs: { data: data[indextr].documentType } }, [
                    _vm._v(" " + _vm._s(tr.documentType.label) + " ")
                  ]),
                  _c("vs-td", { attrs: { data: data[indextr] } }, [
                    _vm._v(" " + _vm._s(tr.documentNumber) + " ")
                  ]),
                  _c("vs-td", { attrs: { data: data[indextr] } }, [
                    _vm._v(" " + _vm._s(_vm._f("amount")(tr.amount)) + " ")
                  ]),
                  _c("vs-td", { attrs: { data: data[indextr] } }, [
                    _vm._v(" " + _vm._s(tr.emitedBy) + " ")
                  ])
                ],
                1
              )
            })
          }
        }
      ]),
      model: {
        value: _vm.documentsSelected,
        callback: function($$v) {
          _vm.documentsSelected = $$v
        },
        expression: "documentsSelected"
      }
    },
    [
      _c(
        "template",
        { slot: "thead" },
        [
          _c("vs-th", [_vm._v("Tipo documento")]),
          _c("vs-th", [_vm._v("Nº documento")]),
          _c("vs-th", [_vm._v("Monto")]),
          _c("vs-th", [_vm._v("Emitida por")])
        ],
        1
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }